const S = {
  wrapper:      { marginTop:'10px', padding:'40px', border:'3px solid grey', fontFamily:"'Georgia', serif", color:'#1a1a2e', lineHeight:'1.7' },
  h1:           { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #c0392b', paddingBottom:'8px', marginBottom:'24px', color:'#7B0D0D' },
  h2:           { fontSize:'1.3rem', fontWeight:'700', color:'#c0392b', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #c0392b', paddingLeft:'10px' },
  p:            { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox:      { background:'#FEF0F0', border:'2px solid #c0392b', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#7B0D0D', marginBottom:'8px' },
  infoBoxItem:  { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #c0392b' },
  table:        { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th:           { background:'#c0392b', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE:          { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff5f5' },
  tdO:          { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff' },
  tdL:          { fontWeight:'600', color:'#7B0D0D', whiteSpace:'nowrap', width:'220px' },
  code:         { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap:        { margin:'24px 0', background:'#fffafa', border:'1px solid #f0cece', borderRadius:'8px', padding:'20px' },
  dTitle:       { fontWeight:'700', fontSize:'0.95rem', color:'#7B0D0D', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption:     { fontSize:'0.84rem', color:'#555', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Explanation / Formula</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// ── Shared SVG arrow markers ──────────────────────────────────────
function Defs() {
  return (
    <defs>
      <marker id="aR" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill="#c0392b"/></marker>
      <marker id="aB" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill="#2E75B6"/></marker>
      <marker id="aG" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill="#27ae60"/></marker>
      <marker id="aO" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill="#e07b00"/></marker>
      <marker id="aP" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill="#9b59b6"/></marker>
      <marker id="aK" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill="#555"/></marker>
    </defs>
  );
}

// Spring coil path helper
function sp(x0, x1, y, n=8) {
  const cw=(x1-x0)/n; const pts=[[x0,y]];
  for(let i=0;i<n;i++){pts.push([x0+i*cw+cw*0.25,y-14]);pts.push([x0+i*cw+cw*0.75,y+14]);}
  pts.push([x1,y]);
  return pts.map((p,i)=>`${i===0?'M':'L'}${p[0].toFixed(1)},${p[1].toFixed(1)}`).join(' ');
}
// Wall helper
function Wall({x,y,h,dir='left'}) {
  const tks=[]; for(let ty=y;ty<y+h;ty+=18)tks.push(ty);
  return(<><rect x={x} y={y} width={11} height={h} fill="#888"/>
    {tks.map(ty=><line key={ty} x1={dir==='left'?x:x+11} y1={ty} x2={dir==='left'?x-13:x+24} y2={ty+14} stroke="#888" strokeWidth="1.5"/>)}</>);
}
// Ground helper
function Gnd({x1,x2,y}) {
  const tks=[]; for(let x=x1;x<=x2;x+=22)tks.push(x);
  return(<><line x1={x1} y1={y} x2={x2} y2={y} stroke="#555" strokeWidth="2"/>
    {tks.map(x=><line key={x} x1={x} y1={y} x2={x-12} y2={y+15} stroke="#555" strokeWidth="1.5"/>)}</>);
}
// Matrix bracket helper (draws a [ or ] bracket)
function Bracket({x,y,h,side,color='#1a1a2e'}) {
  const w=8;
  if(side==='left')  return <path d={`M ${x+w},${y} L ${x},${y} L ${x},${y+h} L ${x+w},${y+h}`} fill="none" stroke={color} strokeWidth="2"/>;
  return <path d={`M ${x},${y} L ${x+w},${y} L ${x+w},${y+h} L ${x},${y+h}`} fill="none" stroke={color} strokeWidth="2"/>;
}

// ─────────────────────────────────────────────────────────────────
// Diagram 1  —  2-DOF physical model and FBDs
// ─────────────────────────────────────────────────────────────────
function DiagTwoDOFModel() {
  const W=900, H=400;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>2-DOF System — Physical Model, Free Body Diagrams &amp; Equations of Motion</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <Defs/>

        {/* ── LEFT: physical setup ─────────────────────── */}
        <rect x={10} y={10} width={370} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={195} y={30} textAnchor="middle" fontSize="14" fill="#7B0D0D" fontWeight="700">Physical System</text>

        {/* Wall */}
        <Wall x={18} y={50} h={250}/>

        {/* Spring k1 */}
        <path d={sp(29,145,150,8)} fill="none" stroke="#27ae60" strokeWidth="2.5"/>
        <text x={87} y={132} textAnchor="middle" fontSize="13" fill="#27ae60" fontWeight="700">k₁</text>

        {/* Mass 1 */}
        <rect x={145} y={118} width={86} height={64} rx={5} fill="#2E75B6" stroke="#1a5276" strokeWidth="2.5"/>
        <text x={188} y={155} textAnchor="middle" fontSize="20" fill="#fff" fontWeight="700">m₁</text>

        {/* Spring k2 (coupling spring) */}
        <path d={sp(231,305,150,8)} fill="none" stroke="#c0392b" strokeWidth="2.5"/>
        <text x={268} y={132} textAnchor="middle" fontSize="13" fill="#c0392b" fontWeight="700">k₂</text>
        <text x={268} y={120} textAnchor="middle" fontSize="11" fill="#c0392b" fontStyle="italic">(coupling)</text>

        {/* Mass 2 */}
        <rect x={305} y={118} width={86} height={64} rx={5} fill="#e07b00" stroke="#b7510a" strokeWidth="2.5"/>
        <text x={348} y={155} textAnchor="middle" fontSize="20" fill="#fff" fontWeight="700">m₂</text>

        {/* Rollers m1 */}
        {[162,208].map(cx=><g key={cx}><circle cx={cx} cy={286} r={11} fill="#888" stroke="#555" strokeWidth="1.8"/><circle cx={cx} cy={286} r={4} fill="#fff"/></g>)}
        {/* Rollers m2 */}
        {[322,368].map(cx=><g key={cx}><circle cx={cx} cy={286} r={11} fill="#888" stroke="#555" strokeWidth="1.8"/><circle cx={cx} cy={286} r={4} fill="#fff"/></g>)}

        {/* Ground */}
        <Gnd x1={29} x2={392} y={286}/>

        {/* x1, x2 displacement arrows */}
        <line x1={152} y1={112} x2={222} y2={112} stroke="#2E75B6" strokeWidth="2" strokeDasharray="5,3" markerEnd="url(#aB)"/>
        <text x={186} y={106} textAnchor="middle" fontSize="12" fill="#2E75B6" fontWeight="700">x₁(t)</text>
        <text x={148} y={106} fontSize="11" fill="#2E75B6">0</text>

        <line x1={312} y1={112} x2={382} y2={112} stroke="#e07b00" strokeWidth="2" strokeDasharray="5,3" markerEnd="url(#aO)"/>
        <text x={346} y={106} textAnchor="middle" fontSize="12" fill="#e07b00" fontWeight="700">x₂(t)</text>
        <text x={308} y={106} fontSize="11" fill="#e07b00">0</text>

        {/* Applied forces */}
        <line x1={391} y1={150} x2={358} y2={150} stroke="#c0392b" strokeWidth="2.5" markerEnd="url(#aR)"/>
        <text x={395} y={155} fontSize="12" fill="#c0392b" fontWeight="700">F₂</text>

        {/* DOF label */}
        <text x={195} y={318} textAnchor="middle" fontSize="12" fill="#555">n = 2 DOF: coordinates x₁, x₂</text>
        <text x={195} y={334} textAnchor="middle" fontSize="12" fill="#555">2 natural frequencies: ω₁, ω₂</text>
        <text x={195} y={350} textAnchor="middle" fontSize="12" fill="#555">2 mode shapes: φ₁, φ₂</text>

        {/* ── MIDDLE: FBDs ─────────────────────────────── */}
        <rect x={390} y={10} width={260} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={520} y={30} textAnchor="middle" fontSize="14" fill="#7B0D0D" fontWeight="700">Free Body Diagrams</text>

        {/* FBD mass 1 */}
        <rect x={410} y={55} width={80} height={56} rx={4} fill="#2E75B6" stroke="#1a5276" strokeWidth="2"/>
        <text x={450} y={87} textAnchor="middle" fontSize="16" fill="#fff" fontWeight="700">m₁</text>
        {/* k1 x1 restoring (left) */}
        <line x1={410} y1={83} x2={366} y2={83} stroke="#27ae60" strokeWidth="2.5" markerEnd="url(#aG)"/>
        <text x={352} y={78} textAnchor="end" fontSize="11" fill="#27ae60" fontWeight="700">k₁x₁</text>
        {/* k2(x2-x1) coupling (right) */}
        <line x1={490} y1={83} x2={534} y2={83} stroke="#c0392b" strokeWidth="2.5" markerEnd="url(#aR)"/>
        <text x={538} y={78} fontSize="11" fill="#c0392b" fontWeight="700">k₂(x₂−x₁)</text>
        {/* Newton eq */}
        <text x={450} y={128} textAnchor="middle" fontSize="11" fill="#7B0D0D" fontWeight="700">m₁ẍ₁ = −k₁x₁ + k₂(x₂−x₁)</text>
        <text x={450} y={144} textAnchor="middle" fontSize="11" fill="#555" fontFamily="'Courier New',monospace">m₁ẍ₁+(k₁+k₂)x₁−k₂x₂ = 0</text>

        {/* Separator */}
        <line x1={398} y1={158} x2={642} y2={158} stroke="#f0cece" strokeWidth="1"/>

        {/* FBD mass 2 */}
        <rect x={450} y={168} width={80} height={56} rx={4} fill="#e07b00" stroke="#b7510a" strokeWidth="2"/>
        <text x={490} y={200} textAnchor="middle" fontSize="16" fill="#fff" fontWeight="700">m₂</text>
        {/* k2(x2-x1) restoring (left) */}
        <line x1={450} y1={196} x2={406} y2={196} stroke="#c0392b" strokeWidth="2.5" markerEnd="url(#aR)"/>
        <text x={392} y={191} textAnchor="end" fontSize="11" fill="#c0392b" fontWeight="700">k₂(x₂−x₁)</text>
        {/* F2 applied (right) */}
        <line x1={530} y1={196} x2={574} y2={196} stroke="#9b59b6" strokeWidth="2.5" markerEnd="url(#aP)"/>
        <text x={578} y={201} fontSize="11" fill="#9b59b6" fontWeight="700">F₂</text>
        {/* Newton eq */}
        <text x={490} y={240} textAnchor="middle" fontSize="11" fill="#7B0D0D" fontWeight="700">m₂ẍ₂ = −k₂(x₂−x₁) + F₂</text>
        <text x={490} y={256} textAnchor="middle" fontSize="11" fill="#555" fontFamily="'Courier New',monospace">m₂ẍ₂−k₂x₁+k₂x₂ = F₂</text>

        {/* ── RIGHT: matrix form ────────────────────────── */}
        <rect x={660} y={10} width={230} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={775} y={30} textAnchor="middle" fontSize="14" fill="#7B0D0D" fontWeight="700">Matrix Form</text>

        {/* [M]{ẍ} + [K]{x} = {F} */}
        <text x={775} y={56} textAnchor="middle" fontSize="13" fill="#1a1a2e" fontWeight="700">[M]ẍ + [K]x = F</text>

        {/* [M] matrix */}
        <text x={672} y={84} fontSize="12" fill="#7B0D0D" fontWeight="700">[M] =</text>
        <Bracket x={706} y={90} h={46} side="left" color="#2E75B6"/>
        <Bracket x={748} y={90} h={46} side="right" color="#2E75B6"/>
        <text x={715} y={110} fontSize="12" fill="#2E75B6" fontFamily="'Courier New',monospace">m₁</text>
        <text x={715} y={128} fontSize="12" fill="#2E75B6" fontFamily="'Courier New',monospace"> 0</text>
        <text x={732} y={110} fontSize="12" fill="#2E75B6" fontFamily="'Courier New',monospace"> 0</text>
        <text x={732} y={128} fontSize="12" fill="#2E75B6" fontFamily="'Courier New',monospace">m₂</text>
        <text x={672} y={152} fontSize="10" fill="#555" fontStyle="italic">diagonal — lumped masses</text>

        {/* [K] matrix */}
        <text x={672} y={178} fontSize="12" fill="#7B0D0D" fontWeight="700">[K] =</text>
        <Bracket x={706} y={184} h={46} side="left" color="#c0392b"/>
        <Bracket x={762} y={184} h={46} side="right" color="#c0392b"/>
        <text x={712} y={204} fontSize="11" fill="#c0392b" fontFamily="'Courier New',monospace">k₁+k₂</text>
        <text x={712} y={222} fontSize="11" fill="#c0392b" fontFamily="'Courier New',monospace"> −k₂</text>
        <text x={744} y={204} fontSize="11" fill="#c0392b" fontFamily="'Courier New',monospace">−k₂</text>
        <text x={744} y={222} fontSize="11" fill="#c0392b" fontFamily="'Courier New',monospace"> k₂</text>
        <text x={672} y={244} fontSize="10" fill="#555" fontStyle="italic">symmetric, banded</text>

        {/* {x}, {F} vectors */}
        <text x={672} y={268} fontSize="12" fill="#7B0D0D" fontWeight="700">x =</text>
        <Bracket x={695} y={274} h={42} side="left" color="#555"/>
        <Bracket x={720} y={274} h={42} side="right" color="#555"/>
        <text x={701} y={294} fontSize="12" fill="#555" fontFamily="'Courier New',monospace">x₁</text>
        <text x={701} y={310} fontSize="12" fill="#555" fontFamily="'Courier New',monospace">x₂</text>

        <text x={740} y={268} fontSize="12" fill="#7B0D0D" fontWeight="700">F =</text>
        <Bracket x={763} y={274} h={42} side="left" color="#9b59b6"/>
        <Bracket x={788} y={274} h={42} side="right" color="#9b59b6"/>
        <text x={769} y={294} fontSize="12" fill="#9b59b6" fontFamily="'Courier New',monospace">0</text>
        <text x={769} y={310} fontSize="12" fill="#9b59b6" fontFamily="'Courier New',monospace">F₂</text>

        {/* Note on coupling */}
        <rect x={668} y={332} width={218} height={58} rx={3} fill="#FEF0F0" stroke="#c0392b" strokeWidth="1"/>
        <text x={674} y={348} fontSize="11" fill="#7B0D0D" fontWeight="700">Off-diagonal −k₂ terms</text>
        <text x={674} y={364} fontSize="11" fill="#444">couple the two equations</text>
        <text x={674} y={380} fontSize="11" fill="#444">→ cannot solve separately</text>
      </svg>
      <div style={S.dCaption}>
        For the 2-DOF system, Newton's second law applied to each mass gives two coupled equations. Written together in matrix form: [M]ẍ + [K]x = F. The off-diagonal terms −k₂ in [K] are the mathematical signature of coupling — because mass 1's equation contains x₂ and mass 2's equation contains x₁, neither can be solved independently of the other. The system has exactly 2 natural frequencies and 2 mode shapes.
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────
// Diagram 2  —  Mass, stiffness, damping matrix anatomy
// ─────────────────────────────────────────────────────────────────
function DiagMatrices() {
  const W=900, H=420;

  // 3-DOF example for visual richness
  const mc = '#2E75B6', kc = '#c0392b', cc = '#27ae60';

  // Helper: draw a 3x3 matrix
  const Matrix3 = ({label, labelColor, entries, x, y, bcolor, note}) => {
    const cw=54, rh=26, bx=x+60;
    return (
      <g>
        <text x={x} y={y+42} fontSize="13" fill={labelColor} fontWeight="700">{label}</text>
        <Bracket x={bx}      y={y}     h={3*rh+4} side="left"  color={bcolor}/>
        <Bracket x={bx+3*cw} y={y}     h={3*rh+4} side="right" color={bcolor}/>
        {entries.map(({row,col,val,bold,hi})=>(
          <text key={`${row}${col}`}
            x={bx+col*cw+10} y={y+row*rh+18}
            fontSize="11" fill={hi||bcolor} fontFamily="'Courier New',monospace"
            fontWeight={bold?'700':'400'}>{val}</text>
        ))}
        {note && <text x={bx} y={y+3*rh+22} fontSize="10" fill="#555" fontStyle="italic">{note}</text>}
      </g>
    );
  };

  const mEntries = [
    {row:0,col:0,val:'m₁',bold:true,hi:mc},{row:0,col:1,val:' 0',hi:'#aaa'},{row:0,col:2,val:' 0',hi:'#aaa'},
    {row:1,col:0,val:' 0',hi:'#aaa'},{row:1,col:1,val:'m₂',bold:true,hi:mc},{row:1,col:2,val:' 0',hi:'#aaa'},
    {row:2,col:0,val:' 0',hi:'#aaa'},{row:2,col:1,val:' 0',hi:'#aaa'},{row:2,col:2,val:'m₃',bold:true,hi:mc},
  ];

  const kEntries = [
    {row:0,col:0,val:'k₁+k₂',bold:true,hi:kc},{row:0,col:1,val:'−k₂',hi:kc},{row:0,col:2,val:'  0',hi:'#aaa'},
    {row:1,col:0,val:'−k₂',hi:kc},{row:1,col:1,val:'k₂+k₃',bold:true,hi:kc},{row:1,col:2,val:'−k₃',hi:kc},
    {row:2,col:0,val:'  0',hi:'#aaa'},{row:2,col:1,val:'−k₃',hi:kc},{row:2,col:2,val:'  k₃',bold:true,hi:kc},
  ];

  const cEntries = [
    {row:0,col:0,val:'c₁+c₂',bold:true,hi:cc},{row:0,col:1,val:'−c₂',hi:cc},{row:0,col:2,val:'  0',hi:'#aaa'},
    {row:1,col:0,val:'−c₂',hi:cc},{row:1,col:1,val:'c₂+c₃',bold:true,hi:cc},{row:1,col:2,val:'−c₃',hi:cc},
    {row:2,col:0,val:'  0',hi:'#aaa'},{row:2,col:1,val:'−c₃',hi:cc},{row:2,col:2,val:'  c₃',bold:true,hi:cc},
  ];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Mass [M], Stiffness [K], Damping [C] Matrices — 3-DOF Chain System</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <Defs/>

        {/* ── TOP: 3-DOF chain diagram ── */}
        <rect x={10} y={10} width={880} height={100} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={450} y={28} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">3-DOF Chain System (3 masses, 3 springs, 3 dampers)</text>

        {/* Wall */}
        <Wall x={18} y={38} h={52}/>

        {/* Spring-damper pairs and masses */}
        {[0,1,2].map(i => {
          const x0 = 29+i*256, x1 = x0+180, mx2 = x1;
          return (
            <g key={i}>
              <path d={sp(x0, x0+90, 60, 6)} fill="none" stroke="#c0392b" strokeWidth="2"/>
              <text x={x0+45} y={50} textAnchor="middle" fontSize="11" fill="#c0392b" fontWeight="700">k{i+1}</text>
              {/* Damper */}
              <rect x={x0+92} y={54} width={54} height={16} rx={3} fill="#ddd" stroke="#888" strokeWidth="1.2"/>
              <rect x={x0+94} y={56} width={50} height={12} rx={2} fill="#b3cde3" opacity="0.7"/>
              <rect x={x0+146} y={52} width={7} height={20} rx={1} fill="#555"/>
              <line x1={x0+153} y1={61} x2={x0+170} y2={61} stroke="#888" strokeWidth="2"/>
              <text x={x0+118} y={50} textAnchor="middle" fontSize="11" fill="#27ae60" fontWeight="700">c{i+1}</text>
              {/* Mass block */}
              <rect x={mx2} y={44} width={60} height={36} rx={4} fill={['#2E75B6','#e07b00','#9b59b6'][i]} stroke={['#1a5276','#b7510a','#6c3483'][i]} strokeWidth="2"/>
              <text x={mx2+30} y={66} textAnchor="middle" fontSize="13" fill="#fff" fontWeight="700">m{i+1}</text>
            </g>
          );
        })}

        {/* Right wall */}
        <Wall x={869} y={38} h={52} dir="right"/>

        {/* ── THREE MATRIX PANELS ── */}

        {/* [M] panel */}
        <rect x={10} y={120} width={278} height={H-130} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={149} y={142} textAnchor="middle" fontSize="14" fill={mc} fontWeight="700">Mass Matrix  [M]</text>

        <Matrix3 label="[M] =" labelColor={mc} entries={mEntries} x={18} y={155} bcolor={mc}
          note="Always diagonal for lumped masses"/>

        <rect x={18} y={248} width={262} height={100} rx={3} fill="#eaf3ff" stroke={mc} strokeWidth="1"/>
        <text x={24} y={265} fontSize="12" fill="#7B0D0D" fontWeight="700">Properties:</text>
        <text x={24} y={281} fontSize="11" fill="#444">{'\u2022'} Diagonal: Mᵢⱼ = mᵢ if i=j, else 0</text>
        <text x={24} y={297} fontSize="11" fill="#444">{'\u2022'} Symmetric and positive definite</text>
        <text x={24} y={313} fontSize="11" fill="#444">{'\u2022'} Off-diagonal terms appear only</text>
        <text x={24} y={329} fontSize="11" fill="#444">  if coordinates share kinetic energy</text>
        <text x={24} y={345} fontSize="11" fill="#444">{'\u2022'} Invertible: M⁻¹ always exists</text>

        <rect x={18} y={354} width={262} height={56} rx={3} fill="#fafafa" stroke={mc} strokeWidth="1"/>
        <text x={24} y={370} fontSize="11" fill="#7B0D0D" fontWeight="700">Consistent mass matrix:</text>
        <text x={24} y={386} fontSize="10" fill="#444">In FEA, distributed mass gives non-diagonal</text>
        <text x={24} y={400} fontSize="10" fill="#444">[M] from shape function integration</text>

        {/* [K] panel */}
        <rect x={306} y={120} width={278} height={H-130} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={445} y={142} textAnchor="middle" fontSize="14" fill={kc} fontWeight="700">Stiffness Matrix  [K]</text>

        <Matrix3 label="[K] =" labelColor={kc} entries={kEntries} x={314} y={155} bcolor={kc}
          note="Symmetric, banded, semi-positive definite"/>

        <rect x={314} y={248} width={262} height={100} rx={3} fill="#FEF0F0" stroke={kc} strokeWidth="1"/>
        <text x={320} y={265} fontSize="12" fill="#7B0D0D" fontWeight="700">Properties:</text>
        <text x={320} y={281} fontSize="11" fill="#444">{'\u2022'} Symmetric: Kᵢⱼ = Kⱼᵢ (always)</text>
        <text x={320} y={297} fontSize="11" fill="#444">{'\u2022'} Diagonal: sum of springs at node i</text>
        <text x={320} y={313} fontSize="11" fill="#444">{'\u2022'} Off-diagonal: −kᵢⱼ for connected pair</text>
        <text x={320} y={329} fontSize="11" fill="#444">{'\u2022'} Singular if rigid-body motion allowed</text>
        <text x={320} y={345} fontSize="11" fill="#444">{'\u2022'} Banded: only adjacent DOFs coupled</text>

        <rect x={314} y={354} width={262} height={56} rx={3} fill="#fafafa" stroke={kc} strokeWidth="1"/>
        <text x={320} y={370} fontSize="11" fill="#7B0D0D" fontWeight="700">Assembly rule:</text>
        <text x={320} y={386} fontSize="10" fill="#444">Spring kᵢⱼ between DOF i,j adds +k to Kᵢᵢ,</text>
        <text x={320} y={400} fontSize="10" fill="#444">+k to Kⱼⱼ, and −k to Kᵢⱼ and Kⱼᵢ</text>

        {/* [C] panel */}
        <rect x={602} y={120} width={288} height={H-130} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={746} y={142} textAnchor="middle" fontSize="14" fill={cc} fontWeight="700">Damping Matrix  [C]</text>

        <Matrix3 label="[C] =" labelColor={cc} entries={cEntries} x={610} y={155} bcolor={cc}
          note="Same structure as [K] for viscous damping"/>

        <rect x={610} y={248} width={272} height={100} rx={3} fill="#f0fff4" stroke={cc} strokeWidth="1"/>
        <text x={616} y={265} fontSize="12" fill="#7B0D0D" fontWeight="700">Properties:</text>
        <text x={616} y={281} fontSize="11" fill="#444">{'\u2022'} Same topology as [K] for dashpots</text>
        <text x={616} y={297} fontSize="11" fill="#444">{'\u2022'} Rayleigh damping: [C]=\u03B1[M]+\u03B2[K]</text>
        <text x={616} y={313} fontSize="11" fill="#444">{'\u2022'} Proportional damping preserves mode</text>
        <text x={616} y={329} fontSize="11" fill="#444">  shapes (allows modal uncoupling)</text>
        <text x={616} y={345} fontSize="11" fill="#444">{'\u2022'} General [C] couples modal equations</text>

        <rect x={610} y={354} width={272} height={56} rx={3} fill="#fafafa" stroke={cc} strokeWidth="1"/>
        <text x={616} y={370} fontSize="11" fill="#7B0D0D" fontWeight="700">Rayleigh coefficients:</text>
        <text x={616} y={386} fontSize="10" fill="#444">{"ζᵢ = (α/2ωᵢ) + (β·ωᵢ/2)"}</text>
        <text x={616} y={400} fontSize="10" fill="#444">Solve for α, β given ζ at two frequencies</text>
      </svg>
      <div style={S.dCaption}>
        The three system matrices capture different physics. [M] stores inertia: diagonal entries are the lumped masses, off-diagonal zeros (for lumped systems). [K] stores stiffness: diagonal entries sum all springs at a node; off-diagonal entries are the negative of the connecting spring — making it symmetric and banded. [C] follows the same pattern as [K] for viscous dashpots. Rayleigh (proportional) damping [C] = α[M] + β[K] is widely used because it preserves the ability to decouple modal equations.
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────
// Diagram 3  —  Eigenvalue problem and natural frequencies
// ─────────────────────────────────────────────────────────────────
function DiagEigenvalue() {
  const W=900, H=380;

  // 2-DOF: m1=m2=m, k1=k2=k  →  ω1²=k/m, ω2²=3k/m
  // φ1 = [1, 1]/√2  φ2 = [1,-1]/√2
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Eigenvalue Problem — Finding Natural Frequencies from [K] and [M]</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <Defs/>

        {/* ── LEFT: derivation steps ─── */}
        <rect x={10} y={10} width={420} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={220} y={30} textAnchor="middle" fontSize="14" fill="#7B0D0D" fontWeight="700">Derivation — Undamped Free Vibration</text>

        {[
          { y:44,  bg:'#fafafa', bc:'#555', title:'Step 1: Start from EOM (undamped, free)',
            lines:['[M]ẍ + [K]x = 0'] },
          { y:96,  bg:'#eaf3ff', bc:'#2E75B6', title:'Step 2: Assume harmonic solution',
            lines:['x(t) = {φ} cos(ωt)', 'Substituting: ẍ = −ω²{φ}cos(ωt)'] },
          { y:162, bg:'#FEF0F0', bc:'#c0392b', title:'Step 3: Eigenvalue equation',
            lines:['([K] − ω²[M]){φ} = {0}', 'Non-trivial solution requires:', 'det([K] − ω²[M]) = 0'] },
          { y:244, bg:'#f0fff4', bc:'#27ae60', title:'Step 4: Solve characteristic equation',
            lines:['Expanding det = 0 gives polynomial in ω²', 'n-DOF system → degree-n polynomial', 'n roots: ω₁² ≤ ω₂² ≤ … ≤ ωₙ²', 'These are the n natural frequencies²'] },
          { y:322, bg:'#fff5e6', bc:'#e07b00', title:'Step 5: Find mode shapes',
            lines:['For each ωᵣ², substitute back:', '([K] − ωᵣ²[M]){φᵣ} = {0}', 'Solve for eigenvector {φᵣ}', '(shape is determined, not amplitude)'] },
        ].map(({y,bg,bc,title,lines}) => (
          <g key={y}>
            <rect x={16} y={y} width={408} height={lines.length*18+28} rx={3} fill={bg} stroke={bc} strokeWidth="1.2"/>
            <text x={22} y={y+16} fontSize="12" fill="#7B0D0D" fontWeight="700">{title}</text>
            {lines.map((l,i) => <text key={i} x={22} y={y+32+i*18} fontSize="12" fill="#333" fontFamily="'Courier New',monospace">{l}</text>)}
          </g>
        ))}

        {/* ── RIGHT: worked example m1=m2=m, k1=k2=k ── */}
        <rect x={440} y={10} width={450} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={665} y={30} textAnchor="middle" fontSize="14" fill="#7B0D0D" fontWeight="700">Worked Example: m₁=m₂=m, k₁=k₂=k</text>

        {/* System params */}
        <rect x={448} y={40} width={434} height={34} rx={3} fill="#fafafa" stroke="#f0cece"/>
        <text x={665} y={55} textAnchor="middle" fontSize="12" fill="#555">[M] = m·I ,   [K] = k·[2  −1; −1  1]</text>
        <text x={665} y={68} textAnchor="middle" fontSize="11" fill="#555" fontStyle="italic">( wall — m₁ — k — m₂ — free end )</text>

        {/* det equation */}
        <rect x={448} y={82} width={434} height={64} rx={3} fill="#FEF0F0" stroke="#c0392b" strokeWidth="1.2"/>
        <text x={454} y={98} fontSize="12" fill="#7B0D0D" fontWeight="700">Characteristic equation:</text>
        <text x={454} y={116} fontSize="12" fill="#333" fontFamily="'Courier New',monospace">det = (2k−mω²)(k−mω²) − k² = 0</text>
        <text x={454} y={134} fontSize="12" fill="#333" fontFamily="'Courier New',monospace">m²ω⁴ − 3mkω² + k² = 0</text>

        {/* Roots */}
        <rect x={448} y={154} width={434} height={76} rx={3} fill="#f0fff4" stroke="#27ae60" strokeWidth="1.2"/>
        <text x={454} y={170} fontSize="12" fill="#7B0D0D" fontWeight="700">Natural frequencies (quadratic in ω²):</text>
        <text x={454} y={188} fontSize="13" fill="#27ae60" fontFamily="'Courier New',monospace" fontWeight="700">ω₁² = (3−√5)k/(2m) ≈ 0.382 k/m</text>
        <text x={454} y={208} fontSize="13" fill="#27ae60" fontFamily="'Courier New',monospace" fontWeight="700">ω₂² = (3+√5)k/(2m) ≈ 2.618 k/m</text>
        <text x={454} y={224} fontSize="11" fill="#555" fontStyle="italic">ω₁ = 0.618√(k/m) ,  ω₂ = 1.618√(k/m)</text>

        {/* Mode shapes */}
        <rect x={448} y={238} width={434} height={100} rx={3} fill="#eaf3ff" stroke="#2E75B6" strokeWidth="1.2"/>
        <text x={454} y={254} fontSize="12" fill="#7B0D0D" fontWeight="700">Mode shapes (from back-substitution):</text>
        <text x={454} y={272} fontSize="12" fill="#2E75B6" fontFamily="'Courier New',monospace">Mode 1: {'{'}φ₁{'}'} = {'{'}1,  1.618{'}'} (masses in phase)</text>
        <text x={454} y={290} fontSize="12" fill="#c0392b" fontFamily="'Courier New',monospace">Mode 2: {'{'}φ₂{'}'} = {'{'}1, −0.618{'}'} (masses out of phase)</text>
        <text x={454} y={312} fontSize="11" fill="#555">Only the ratio matters — amplitude is arbitrary.</text>
        <text x={454} y={328} fontSize="11" fill="#555">Orthogonality: {'{'}φ₁{'}'}ᵀ[M]{'{'}φ₂{'}'} = 0 and {'{'}φ₁{'}'}ᵀ[K]{'{'}φ₂{'}'} = 0</text>

        {/* Key insight */}
        <rect x={448} y={346} width={434} height={26} rx={3} fill="#1a1a2e" opacity="0.07"/>
        <text x={665} y={363} textAnchor="middle" fontSize="11" fill="#555">n-DOF system always has exactly n natural frequencies and n orthogonal mode shapes</text>
      </svg>
      <div style={S.dCaption}>
        The eigenvalue problem ([K] − ω²[M])φ = 0 is solved by setting the determinant to zero, yielding the characteristic polynomial. For n DOF this is a degree-n polynomial in ω², giving n natural frequencies. Each frequency is then back-substituted to find the corresponding eigenvector (mode shape). The mode shapes are orthogonal with respect to both [M] and [K] — a property that enables modal decoupling.
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────
// Diagram 4  —  Mode shapes visualised for 3-DOF chain
// ─────────────────────────────────────────────────────────────────
function DiagModeShapes() {
  const W=900, H=420;

  // 3-DOF free-free chain: m₁=m₂=m₃=m, k₁=k₂=k₃=k
  // Exact modes for 3-DOF fixed-free:
  // ω₁²=0.198k/m, ω₂²=1.555k/m, ω₃²=3.247k/m (approx)
  // Mode shapes (normalised, fixed-free):
  const modes = [
    { label:'Mode 1 (ω₁ — lowest)',  color:'#2E75B6', amps:[0.445, 0.802, 1.000], desc:'All masses move in same direction. Long wavelength. Node only at wall.' },
    { label:'Mode 2 (ω₂ — middle)',  color:'#c0392b', amps:[0.802, 0.445,-1.000], desc:'One internal node. m₃ moves opposite to m₁. Short wavelength.' },
    { label:'Mode 3 (ω₃ — highest)', color:'#27ae60', amps:[-1.0,  1.000,-0.445], desc:'Two internal nodes. Rapid alternation. Highest natural frequency.' },
  ];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Normal Mode Shapes — 3-DOF Fixed-Free Chain  (m₁=m₂=m₃=m, k₁=k₂=k₃=k)</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <Defs/>

        {/* Shared system sketch at top */}
        <rect x={10} y={10} width={880} height={58} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={450} y={26} textAnchor="middle" fontSize="12" fill="#7B0D0D" fontWeight="700">Equilibrium Configuration</text>
        {/* Wall */}
        <Wall x={18} y={30} h={30}/>
        {/* Springs and masses */}
        {[0,1,2].map(i => {
          const x0=29+i*248, midX=x0+110;
          return (
            <g key={i}>
              <path d={sp(x0, x0+80, 46, 6)} fill="none" stroke="#888" strokeWidth="1.8"/>
              <rect x={x0+80} y={33} width={50} height={26} rx={3} fill="#888" opacity="0.4" stroke="#555" strokeWidth="1.5"/>
              <text x={x0+105} y={50} textAnchor="middle" fontSize="11" fill="#555" fontWeight="700">m{i+1}</text>
            </g>
          );
        })}
        {/* Free end */}
        <text x={785} y={50} fontSize="11" fill="#888" fontStyle="italic">free</text>

        {/* Three mode panels */}
        {modes.map(({label, color, amps, desc}, mi) => {
          const py = 78 + mi*112;
          const massCx = [145, 393, 641]; // x-centres of masses at equilibrium
          const yEq = py+54; // equilibrium y-line
          const scale = 44; // pixels per unit amplitude

          return (
            <g key={mi}>
              <rect x={10} y={py} width={880} height={108} rx={4} fill="#fafafa" stroke={color} strokeWidth="1.5"/>

              {/* Mode label */}
              <text x={16} y={py+18} fontSize="12" fill={color} fontWeight="700">{label}</text>
              <text x={16} y={py+34} fontSize="11" fill="#555" fontStyle="italic">{desc}</text>

              {/* Equilibrium baseline */}
              <line x1={50} y1={yEq} x2={740} y2={yEq} stroke="#ddd" strokeWidth="1.5" strokeDasharray="5,3"/>
              <text x={46} y={yEq+4} textAnchor="end" fontSize="10" fill="#aaa">eq.</text>

              {/* Wall node (zero displacement) */}
              <line x1={45} y1={py+12} x2={45} y2={py+100} stroke="#888" strokeWidth="2"/>
              <circle cx={45} cy={yEq} r={5} fill="#888"/>

              {/* Mode shape bars + displaced mass positions */}
              {massCx.map((cx, i) => {
                const disp = amps[i]*scale;
                const massY = yEq - disp;
                return (
                  <g key={i}>
                    {/* Vertical bar showing displacement */}
                    <line x1={cx} y1={yEq} x2={cx} y2={massY} stroke={color} strokeWidth="3" opacity="0.5"/>
                    {/* Displaced mass */}
                    <circle cx={cx} cy={massY} r={16} fill={color} stroke="#fff" strokeWidth="2" opacity="0.9"/>
                    <text x={cx} y={massY+4} textAnchor="middle" fontSize="11" fill="#fff" fontWeight="700">m{i+1}</text>
                    {/* Amplitude label */}
                    <text x={cx} y={yEq+(disp>0?14:-6)} textAnchor="middle" fontSize="10" fill={color} fontWeight="700">{amps[i]>0?'+':''}{amps[i].toFixed(3)}</text>
                  </g>
                );
              })}

              {/* Mode shape curve (connect wall + masses with smooth line) */}
              {(() => {
                const xPts = [45, ...massCx];
                const yPts = [yEq, ...amps.map(a => yEq - a*scale)];
                const dPath = xPts.map((x,i)=>`${i===0?'M':'L'}${x},${yPts[i]}`).join(' ');
                return <path d={dPath} fill="none" stroke={color} strokeWidth="2" strokeDasharray="6,3" opacity="0.6"/>;
              })()}

              {/* Node markers (zero crossing) */}
              {massCx.map((cx,i) => {
                if (i>0 && amps[i-1]*amps[i]<0) {
                  // there's a node between mass i-1 and mass i
                  const t = -amps[i-1]/(amps[i]-amps[i-1]);
                  const nx = massCx[i-1]+t*(cx-massCx[i-1]);
                  return (
                    <g key={i}>
                      <circle cx={nx} cy={yEq} r={6} fill="#fff" stroke={color} strokeWidth="2"/>
                      <text x={nx} y={yEq+18} textAnchor="middle" fontSize="10" fill={color} fontWeight="700">node</text>
                    </g>
                  );
                }
                return null;
              })}

              {/* Natural frequency label */}
              <text x={760} y={py+18} fontSize="11" fill={color} fontWeight="700">ω{mi+1}² ≈ {[0.198,1.555,3.247][mi].toFixed(3)} k/m</text>
              <text x={760} y={py+34} fontSize="10" fill="#555">Nodes: {mi}</text>
              <text x={760} y={py+50} fontSize="10" fill="#555">Mode: {mi+1}</text>
            </g>
          );
        })}

        {/* Orthogonality note at bottom */}
        <rect x={10} y={412} width={880} height={0} rx={3}/>
      </svg>
      <div style={S.dCaption}>
        The three mode shapes of a 3-DOF fixed-free chain. Mode 1 (lowest frequency): all masses move in the same direction — zero internal nodes. Mode 2 (middle): one internal node between m₂ and m₃, with m₃ reversing sign. Mode 3 (highest): two internal nodes, rapid alternation. Higher modes always have more nodes. The number of nodes in mode r equals r−1. All three mode shapes are mutually orthogonal with respect to both [M] and [K].
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────
// Diagram 5  —  Modal transformation and uncoupling
// ─────────────────────────────────────────────────────────────────
function DiagModalTransform() {
  const W=900, H=400;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Modal Transformation — Decoupling Coupled Equations of Motion</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <Defs/>

        {/* ── LEFT: the transformation steps ── */}
        <rect x={10} y={10} width={430} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={225} y={30} textAnchor="middle" fontSize="14" fill="#7B0D0D" fontWeight="700">Modal Coordinate Transformation</text>

        {/* Step boxes */}
        {[
          { y:42,  bg:'#fafafa', bc:'#555', title:'Coupled physical equations (n unknowns x)',
            lines:['[M]ẍ + [C]ẋ + [K]x = F(t)', 'Each equation contains multiple xᵢ terms', '→ Must solve all n equations simultaneously'] },
          { y:124, bg:'#eaf3ff', bc:'#2E75B6', title:'Assemble modal matrix [Φ]',
            lines:['[Φ] = [{φ₁} {φ₂} … {φₙ}]  (n×n matrix)', 'Columns are the mode shape vectors', 'Substitute: x = [Φ]{q}  (modal expansion)'] },
          { y:206, bg:'#FEF0F0', bc:'#c0392b', title:'Pre-multiply by [Φ]ᵀ',
            lines:['[Φ]ᵀ[M][Φ]q̈ + [Φ]ᵀ[C][Φ]q̇ + [Φ]ᵀ[K][Φ]q = [Φ]ᵀF', 'Orthogonality: [Φ]ᵀ[M][Φ] = [m*] (diagonal)', '         and  [Φ]ᵀ[K][Φ] = [k*] (diagonal)'] },
          { y:300, bg:'#f0fff4', bc:'#27ae60', title:'Decoupled modal equations (n independent SDOF)',
            lines:['mᵣ*q̈ᵣ + cᵣ*q̇ᵣ + kᵣ*qᵣ = fᵣ*(t)  for r=1…n', 'Each modal equation solved independently!', 'Physical response: x(t) = Σ {φᵣ} qᵣ(t)'] },
        ].map(({y,bg,bc,title,lines}) => (
          <g key={y}>
            <rect x={16} y={y} width={418} height={lines.length*18+28} rx={3} fill={bg} stroke={bc} strokeWidth="1.2"/>
            <text x={22} y={y+16} fontSize="12" fill="#7B0D0D" fontWeight="700">{title}</text>
            {lines.map((l,i) => <text key={i} x={22} y={y+32+i*18} fontSize="11" fill="#333" fontFamily="'Courier New',monospace">{l}</text>)}
          </g>
        ))}

        {/* Arrow flow between steps */}
        {[108,190,284].map(y => (
          <g key={y}>
            <line x1={225} y1={y} x2={225} y2={y+16} stroke="#9b59b6" strokeWidth="2" markerEnd="url(#aP)"/>
          </g>
        ))}

        {/* ── RIGHT: modal quantities and orthogonality ── */}
        <rect x={450} y={10} width={440} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={670} y={30} textAnchor="middle" fontSize="14" fill="#7B0D0D" fontWeight="700">Modal Quantities &amp; Orthogonality</text>

        {/* Modal mass */}
        <rect x={458} y={44} width={424} height={66} rx={3} fill="#eaf3ff" stroke="#2E75B6" strokeWidth="1.2"/>
        <text x={464} y={62} fontSize="12" fill="#7B0D0D" fontWeight="700">Modal mass:   mᵣ* = {'{φᵣ}'}ᵀ [M] {'{φᵣ}'}  (scalar)</text>
        <text x={464} y={80} fontSize="11" fill="#444">Orthogonality: {'{φᵣ}'}ᵀ [M] {'{φₛ}'} = 0 for r ≠ s</text>
        <text x={464} y={98} fontSize="11" fill="#444">→ [Φ]ᵀ[M][Φ] = diag(m₁*, m₂*, …, mₙ*)</text>

        {/* Modal stiffness */}
        <rect x={458} y={118} width={424} height={66} rx={3} fill="#FEF0F0" stroke="#c0392b" strokeWidth="1.2"/>
        <text x={464} y={136} fontSize="12" fill="#7B0D0D" fontWeight="700">Modal stiffness:  kᵣ* = {'{φᵣ}'}ᵀ [K] {'{φᵣ}'}  (scalar)</text>
        <text x={464} y={154} fontSize="11" fill="#444">Orthogonality: {'{φᵣ}'}ᵀ [K] {'{φₛ}'} = 0 for r ≠ s</text>
        <text x={464} y={172} fontSize="11" fill="#444">Also: kᵣ* = ωᵣ²·mᵣ*   (from eigenvalue problem)</text>

        {/* Modal damping (Rayleigh) */}
        <rect x={458} y={192} width={424} height={66} rx={3} fill="#f0fff4" stroke="#27ae60" strokeWidth="1.2"/>
        <text x={464} y={210} fontSize="12" fill="#7B0D0D" fontWeight="700">Modal damping:  cᵣ* = {'{φᵣ}'}ᵀ [C] {'{φᵣ}'}  (scalar)</text>
        <text x={464} y={228} fontSize="11" fill="#444">Rayleigh: cᵣ* = α·mᵣ* + β·kᵣ*  →  ζᵣ = α/(2ωᵣ) + βωᵣ/2</text>
        <text x={464} y={246} fontSize="11" fill="#444">General [C]: off-diagonal after transform → still coupled</text>

        {/* Modal forcing */}
        <rect x={458} y={266} width={424} height={50} rx={3} fill="#fff5e6" stroke="#e07b00" strokeWidth="1.2"/>
        <text x={464} y={284} fontSize="12" fill="#7B0D0D" fontWeight="700">Modal force:   fᵣ*(t) = {'{φᵣ}'}ᵀ F(t)  (scalar)</text>
        <text x={464} y={302} fontSize="11" fill="#444">Projects the physical force onto each mode shape</text>

        {/* Decoupled SDOF equation */}
        <rect x={458} y={324} width={424} height={60} rx={3} fill="#1a1a2e" opacity="0.06" stroke="#555" strokeWidth="1.2"/>
        <text x={670} y={348} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Decoupled SDOF for each mode r:</text>
        <text x={670} y={368} textAnchor="middle" fontSize="13" fill="#1a1a2e" fontFamily="'Courier New',monospace">mᵣ*q̈ᵣ + cᵣ*q̇ᵣ + kᵣ*qᵣ = fᵣ*(t)</text>

        {/* ζr */}
        <text x={670} y={382} textAnchor="middle" fontSize="11" fill="#555">modal damping ratio: ζᵣ = cᵣ*/(2√(kᵣ*mᵣ*))</text>
      </svg>
      <div style={S.dCaption}>
        The modal transformation x = [Φ]q converts n coupled physical equations into n independent SDOF equations in modal coordinates q. The key is orthogonality: mode shapes are orthogonal with respect to both [M] and [K], making [Φ]ᵀ[M][Φ] and [Φ]ᵀ[K][Φ] diagonal. Each modal equation is then an ordinary SDOF problem, solved with all the tools already developed — response is rebuilt by superimposing all modes.
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────
// Diagram 6  —  Coupled vs uncoupled: visual comparison with responses
// ─────────────────────────────────────────────────────────────────
function DiagCoupledUncoupled() {
  const W=900, H=400;

  // 2-DOF response: modal superposition, unit impulse on m1
  // m1=m2=m=1, k1=k2=k=1
  // ω1²=0.382, ω2²=2.618
  // Mode shapes: φ1=[1,1.618]/√(1+1.618²), φ2=[1,-0.618]/√(1+0.618²)
  const ω1=Math.sqrt(0.382), ω2=Math.sqrt(2.618);
  const φ1=[1,1.618], φ2=[1,-0.618];
  const n1=Math.sqrt(φ1[0]**2+φ1[1]**2), n2=Math.sqrt(φ2[0]**2+φ2[1]**2);
  const φ1n=[φ1[0]/n1,φ1[1]/n1], φ2n=[φ2[0]/n2,φ2[1]/n2];

  // Modal forces from unit impulse at DOF1: F=[1,0] at t=0
  // f*1 = φ1n[0]*1, f*2 = φ2n[0]*1
  const f1s=φ1n[0], f2s=φ2n[0];

  // Modal responses (unit modal mass, zero damping):
  // qr(t) = f*r/ωr * sin(ωr*t)
  const dt=0.01, tMax=10;
  const x1pts=[], x2pts=[];
  for(let t=0;t<=tMax;t+=dt){
    const q1=(f1s/ω1)*Math.sin(ω1*t);
    const q2=(f2s/ω2)*Math.sin(ω2*t);
    x1pts.push([t, φ1n[0]*q1+φ2n[0]*q2]);
    x2pts.push([t, φ1n[1]*q1+φ2n[1]*q2]);
  }

  const gX=55, gY=30, gW=480, gH=140;
  const mx2 = t => gX+(t/tMax)*gW;
  const myR = (y,yc) => yc-y*48;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Coupled Physical Response vs Superimposed Modal Contributions</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <Defs/>

        {/* ── TOP: physical x1 and x2 responses ── */}
        <text x={gX} y={gY-6} fontSize="12" fill="#7B0D0D" fontWeight="700">Physical responses x₁(t) and x₂(t) — unit impulse at DOF 1</text>
        <rect x={gX} y={gY} width={gW} height={gH} rx={3} fill="#fafafa" stroke="#ddd"/>

        {/* zero line */}
        <line x1={gX} y1={gY+gH/2} x2={gX+gW} y2={gY+gH/2} stroke="#ddd" strokeWidth="1"/>

        {/* x1 curve */}
        <path d={x1pts.map(([t,y],i)=>`${i===0?'M':'L'}${mx2(t).toFixed(1)},${myR(y,gY+gH/2).toFixed(1)}`).join(' ')} fill="none" stroke="#2E75B6" strokeWidth="2.2"/>
        {/* x2 curve */}
        <path d={x2pts.map(([t,y],i)=>`${i===0?'M':'L'}${mx2(t).toFixed(1)},${myR(y,gY+gH/2).toFixed(1)}`).join(' ')} fill="none" stroke="#e07b00" strokeWidth="2.2"/>

        {/* Axes */}
        <line x1={gX-2} y1={gY} x2={gX-2} y2={gY+gH} stroke="#555" strokeWidth="1.5"/>
        <line x1={gX-2} y1={gY+gH} x2={gX+gW} y2={gY+gH} stroke="#555" strokeWidth="1.5"/>
        {[0,2,4,6,8,10].map(t=>(
          <g key={t}><line x1={mx2(t)} y1={gY+gH} x2={mx2(t)} y2={gY+gH+5} stroke="#555" strokeWidth="1.5"/>
          <text x={mx2(t)} y={gY+gH+16} textAnchor="middle" fontSize="10" fill="#888">{t}s</text></g>
        ))}
        <text x={gX-15} y={gY+gH/2+4} textAnchor="end" fontSize="10" fill="#555">x</text>
        <line x1={gX} y1={gY+gH/2} x2={18} y2={gY+gH/2} stroke="#aaa" strokeWidth="1" strokeDasharray="2"/>
        <text x={549} y={gY+30} fontSize="11" fill="#2E75B6" fontWeight="700">x₁(t)</text>
        <text x={549} y={gY+48} fontSize="11" fill="#e07b00" fontWeight="700">x₂(t)</text>
        <text x={280} y={gY+gH-4} textAnchor="middle" fontSize="10" fill="#555" fontStyle="italic">Contains both ω₁ and ω₂ — irregular, non-periodic pattern</text>

        {/* ── BOTTOM: modal contribution breakdown ── */}
        <text x={gX} y={gY+gH+40} fontSize="12" fill="#7B0D0D" fontWeight="700">Modal contributions: x₁(t) = φ₁₁·q₁(t)  +  φ₁₂·q₂(t)</text>

        {/* Mode 1 contribution */}
        {(() => {
          const y0=gY+gH+56, yc=y0+60;
          const pts1=[]; for(let t=0;t<=tMax;t+=dt)pts1.push([t, φ1n[0]*(f1s/ω1)*Math.sin(ω1*t)]);
          return (
            <g>
              <rect x={gX} y={y0} width={gW} height={70} rx={3} fill="#eaf3ff" stroke="#2E75B6" strokeWidth="1"/>
              <path d={pts1.map(([t,y],i)=>`${i===0?'M':'L'}${mx2(t).toFixed(1)},${(yc-y*62).toFixed(1)}`).join(' ')} fill="none" stroke="#2E75B6" strokeWidth="2"/>
              <line x1={gX} y1={yc} x2={gX+gW} y2={yc} stroke="#ddd" strokeWidth="1"/>
              <text x={gX+8} y={y0+16} fontSize="11" fill="#2E75B6" fontWeight="700">Mode 1 contribution: φ₁₁·q₁(t) — frequency ω₁ = {ω1.toFixed(3)} rad/s</text>
              <text x={gX+8} y={y0+62} fontSize="10" fill="#2E75B6" fontStyle="italic">Pure sinusoid at ω₁</text>
            </g>
          );
        })()}

        {/* Mode 2 contribution */}
        {(() => {
          const y0=gY+gH+136, yc=y0+55;
          const pts2=[]; for(let t=0;t<=tMax;t+=dt)pts2.push([t, φ2n[0]*(f2s/ω2)*Math.sin(ω2*t)]);
          return (
            <g>
              <rect x={gX} y={y0} width={gW} height={70} rx={3} fill="#FEF0F0" stroke="#c0392b" strokeWidth="1"/>
              <path d={pts2.map(([t,y],i)=>`${i===0?'M':'L'}${mx2(t).toFixed(1)},${(yc-y*62).toFixed(1)}`).join(' ')} fill="none" stroke="#c0392b" strokeWidth="2"/>
              <line x1={gX} y1={yc} x2={gX+gW} y2={yc} stroke="#ddd" strokeWidth="1"/>
              <text x={gX+8} y={y0+16} fontSize="11" fill="#c0392b" fontWeight="700">Mode 2 contribution: φ₁₂·q₂(t) — frequency ω₂ = {ω2.toFixed(3)} rad/s</text>
              <text x={gX+8} y={y0+62} fontSize="10" fill="#c0392b" fontStyle="italic">Pure sinusoid at ω₂ (faster oscillation)</text>
            </g>
          );
        })()}

        {/* Sum arrow */}
        <text x={gX+gW/2} y={gY+gH+215} textAnchor="middle" fontSize="13" fill="#27ae60" fontWeight="700">x₁(t) = Mode 1 + Mode 2  (superposition)</text>

        {/* ── RIGHT: key concept panel ── */}
        <rect x={550} y={10} width={340} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={720} y={28} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Coupled vs Uncoupled</text>

        {[
          { y:36,  bg:'#FEF0F0', bc:'#c0392b', label:'Coupled (physical coords)',
            pts:['Equations contain multiple xᵢ','Cannot solve one at a time','Matrix inversion required','Non-periodic combined response'] },
          { y:140, bg:'#f0fff4', bc:'#27ae60', label:'Uncoupled (modal coords)',
            pts:['Each mode = independent SDOF','Solve n scalar equations','Superpose for physical answer','Each mode is a pure sinusoid'] },
          { y:244, bg:'#eaf3ff', bc:'#2E75B6', label:'When coupling matters',
            pts:['Close natural frequencies → strong','coupling between modes in response','Far apart → dominant mode often','sufficient (truncated modal series)'] },
          { y:330, bg:'#fff5e6', bc:'#e07b00', label:'Modal truncation',
            pts:['Only keep r = 1…p modes (p < n)','High modes contribute less (if','loading is smooth/low-frequency)','Reduces n×n problem to p×p'] },
        ].map(({y,bg,bc,label,pts}) => (
          <g key={y}>
            <rect x={558} y={y} width={324} height={pts.length*16+28} rx={3} fill={bg} stroke={bc} strokeWidth="1.2"/>
            <text x={564} y={y+17} fontSize="12" fill="#7B0D0D" fontWeight="700">{label}</text>
            {pts.map((pt,i) => <text key={i} x={564} y={y+33+i*16} fontSize="11" fill="#444">{pt}</text>)}
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>
        The physical responses x₁(t) and x₂(t) are irregular, non-periodic combinations of both natural frequencies (top panel). When decomposed into modal contributions (bottom panels), each mode is a clean sinusoid at a single frequency ω₁ or ω₂ — simple SDOF behaviour. The physical response is the sum of these individual modal responses. This is the power of modal analysis: reduce an n-DOF coupled problem into n independent SDOF problems.
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────
// Diagram 7  —  Orthogonality proof visualised
// ─────────────────────────────────────────────────────────────────
function DiagOrthogonality() {
  const W=900, H=320;

  // 2-DOF with m1=m2=1, k1=k2=k3=1 (symmetric 3-spring chain)
  // Exact modes:
  // ω1²=(2-√2), ω2²=(2+√2)
  // φ1=[1, √2], φ2=[1,-√2] (unnorm)
  const φ1=[1, Math.sqrt(2)], φ2=[1,-Math.sqrt(2)];

  // Modal mass m* = φᵀMφ with M=I
  const m1s=φ1[0]**2+φ1[1]**2, m2s=φ2[0]**2+φ2[1]**2;
  // Cross: φ1ᵀMφ2
  const cross_M=φ1[0]*φ2[0]+φ1[1]*φ2[1];
  // Modal stiffness k*= φᵀKφ, K=[2,-1;-1,2]
  const K=[[2,-1],[-1,2]];
  const Kφ1=[K[0][0]*φ1[0]+K[0][1]*φ1[1], K[1][0]*φ1[0]+K[1][1]*φ1[1]];
  const Kφ2=[K[0][0]*φ2[0]+K[0][1]*φ2[1], K[1][0]*φ2[0]+K[1][1]*φ2[1]];
  const k1s=φ1[0]*Kφ1[0]+φ1[1]*Kφ1[1];
  const k2s=φ2[0]*Kφ2[0]+φ2[1]*Kφ2[1];
  const cross_K=φ1[0]*Kφ2[0]+φ1[1]*Kφ2[1];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Mode Shape Orthogonality — Geometric &amp; Algebraic Demonstration</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <Defs/>

        {/* ── LEFT: geometric view ── */}
        <rect x={10} y={10} width={360} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={185} y={28} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Geometric Visualisation (2-DOF)</text>
        <text x={185} y={44} textAnchor="middle" fontSize="11" fill="#555" fontStyle="italic">Mode vectors in DOF space (x₁, x₂)</text>

        {/* Coordinate axes */}
        {(() => {
          const ox=140, oy=180, sc=100;
          return (
            <>
              <line x1={ox-120} y1={oy} x2={ox+170} y2={oy} stroke="#888" strokeWidth="1.5" markerEnd="url(#aK)"/>
              <line x1={ox} y1={oy+100} x2={ox} y2={oy-120} stroke="#888" strokeWidth="1.5" markerEnd="url(#aK)"/>
              <text x={ox+173} y={oy+4} fontSize="11" fill="#888">x₁</text>
              <text x={ox+5} y={oy-124} fontSize="11" fill="#888">x₂</text>

              {/* Mode 1 vector */}
              <line x1={ox} y1={oy} x2={ox+φ1[0]*sc*0.7} y2={oy-φ1[1]*sc*0.7} stroke="#2E75B6" strokeWidth="3" markerEnd="url(#aB)"/>
              <text x={ox+φ1[0]*sc*0.7+8} y={oy-φ1[1]*sc*0.7} fontSize="13" fill="#2E75B6" fontWeight="700">φ₁=[1,√2]</text>

              {/* Mode 2 vector */}
              <line x1={ox} y1={oy} x2={ox+φ2[0]*sc*0.7} y2={oy-φ2[1]*sc*0.7} stroke="#c0392b" strokeWidth="3" markerEnd="url(#aR)"/>
              <text x={ox+φ2[0]*sc*0.7+8} y={oy-φ2[1]*sc*0.7+8} fontSize="13" fill="#c0392b" fontWeight="700">φ₂=[1,−√2]</text>

              {/* Right angle marker */}
              <text x={ox+60} y={oy-12} fontSize="18" fill="#27ae60" fontWeight="700">⊥</text>
              <text x={ox+52} y={oy+14} fontSize="11" fill="#27ae60" fontWeight="700">M-orthogonal</text>
            </>
          );
        })()}

        <rect x={16} y={240} width={348} height={70} rx={3} fill="#f0fff4" stroke="#27ae60" strokeWidth="1"/>
        <text x={22} y={256} fontSize="11" fill="#7B0D0D" fontWeight="700">M-orthogonality check:</text>
        <text x={22} y={272} fontSize="11" fill="#444" fontFamily="'Courier New',monospace">{"φ₁ᵀ·M·φ₂ = 1×1 + √2×(−√2) = 1−2 = 0 ✓"}</text>
        <text x={22} y={288} fontSize="11" fill="#444" fontFamily="'Courier New',monospace">{"K-orthogonality also holds: φ₁ᵀ·K·φ₂ = 0 ✓"}</text>
        <text x={22} y={304} fontSize="11" fill="#555" fontStyle="italic">Not geometrically perpendicular — M-weighted dot product = 0</text>

        {/* ── RIGHT: numerical table ── */}
        <rect x={380} y={10} width={510} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={635} y={28} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Numerical Verification — m₁=m₂=1, k₁=k₂=k₃=1</text>

        {/* Table of modal quantities */}
        {[['Quantity','Mode 1','Mode 2','Cross (r≠s)'],
          ['Mode shape φᵣ','[1, 1.414]','[1, −1.414]','—'],
          ['Modal mass m* = φᵀMφ',m1s.toFixed(3), m2s.toFixed(3), cross_M.toFixed(6)+'  ✓=0'],
          ['Modal stiffness k* = φᵀKφ',k1s.toFixed(3), k2s.toFixed(3), cross_K.toFixed(6)+'  ✓=0'],
          ['ωᵣ² = k*/m*',(k1s/m1s).toFixed(3),(k2s/m2s).toFixed(3),'—'],
          ['ωᵣ',(Math.sqrt(k1s/m1s)).toFixed(3),'  '+Math.sqrt(k2s/m2s).toFixed(3),'—'],
        ].map(([a,b,c,d],ri) => {
          const ry=44+ri*38, bg=ri===0?'#c0392b':(ri%2===0?'#fff5f5':'#fff');
          return (
            <g key={ri}>
              <rect x={386} y={ry} width={248} height={36} fill={bg} stroke="#f0cece" strokeWidth="0.5"/>
              <rect x={634} y={ry} width={96} height={36}  fill={bg} stroke="#f0cece" strokeWidth="0.5"/>
              <rect x={730} y={ry} width={96} height={36}  fill={bg} stroke="#f0cece" strokeWidth="0.5"/>
              <rect x={826} y={ry} width={58} height={36}  fill={bg} stroke="#f0cece" strokeWidth="0.5"/>
              {[[386,a],[634,b],[730,c],[826,d]].map(([x,txt],ci) => (
                <text key={ci} x={x+5} y={ry+22} fontSize={ri===0?11:10} fill={ri===0?'#fff':'#333'}
                  fontFamily={ri>0?"'Courier New',monospace":'inherit'} fontWeight={ri===0?'700':'400'}>{txt}</text>
              ))}
            </g>
          );
        })}

        {/* Properties summary */}
        {[
          {y:274,bg:'#eaf3ff',bc:'#2E75B6',text:['Mass normalisation: divide φᵣ by √(mᵣ*)',  'Then φᵣᵀ·M·φₛ = δᵣₛ (Kronecker delta)','Mass-normalised modes: M* = I (identity)']},
          {y:344,bg:'#FEF0F0',bc:'#c0392b',text:['Spectral matrix: K* = diag(ω₁², ω₂², …)','Stiffness-normalised: φᵣᵀ·K·φₛ = ωᵣ²·δᵣₛ','Encodes all natural frequencies on diagonal']},
        ].map(({y,bg,bc,text}) => (
          <g key={y}>
            <rect x={386} y={y} width={498} height={text.length*16+22} rx={3} fill={bg} stroke={bc} strokeWidth="1"/>
            {text.map((l,i) => <text key={i} x={392} y={y+18+i*16} fontSize="11" fill="#333">{l}</text>)}
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>
        Mode shapes are orthogonal with respect to [M] and [K], meaning the M-weighted dot product of two different mode shapes is exactly zero. Left: geometrically, mode vectors in DOF-space are not necessarily perpendicular, but their M-weighted inner product vanishes. Right: numerical verification — the cross terms φ₁ᵀMφ₂ and φ₁ᵀKφ₂ are both exactly zero (to numerical precision). This orthogonality is what makes the modal transformation block-diagonalise the system matrices.
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────
// Diagram 8  —  3-DOF to nDOF: general structure and FEA link
// ─────────────────────────────────────────────────────────────────
function DiagGeneralMDOF() {
  const W=900, H=340;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Scaling to n-DOF — Matrix Sparsity, FEA Assembly &amp; Modal Truncation</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <Defs/>

        {/* ── LEFT: n×n matrix sparsity pattern ── */}
        <rect x={10} y={10} width={270} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={145} y={28} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Matrix Sparsity Pattern</text>
        <text x={145} y={44} textAnchor="middle" fontSize="11" fill="#555" fontStyle="italic">8-DOF chain [K] — banded structure</text>

        {/* Draw 8×8 sparse K matrix pattern */}
        {(() => {
          const n=8, cs=28, ox=20, oy=56;
          const cells=[];
          for(let r=0;r<n;r++) for(let c=0;c<n;c++) {
            const onDiag=r===c, onOff=Math.abs(r-c)===1;
            cells.push({r,c,fill:onDiag?'#c0392b':onOff?'#f5b7b1':'#fafafa', stroke:'#ddd'});
          }
          return (
            <g>
              {cells.map(({r,c,fill}) => (
                <rect key={`${r}${c}`} x={ox+c*cs} y={oy+r*cs} width={cs-1} height={cs-1} fill={fill} stroke="#e8d0d0" strokeWidth="0.5" rx="1"/>
              ))}
              {/* Row/col labels */}
              {Array.from({length:n},(_,i) => (
                <g key={i}>
                  <text x={ox+i*cs+cs/2} y={oy-3} textAnchor="middle" fontSize="8" fill="#888">{i+1}</text>
                  <text x={ox-5} y={oy+i*cs+cs/2+3} textAnchor="end" fontSize="8" fill="#888">{i+1}</text>
                </g>
              ))}
              {/* Legend */}
              <rect x={ox} y={oy+n*cs+8} width={12} height={12} fill="#c0392b"/>
              <text x={ox+16} y={oy+n*cs+19} fontSize="10" fill="#444">Diagonal (kᵢ+kᵢ₊₁)</text>
              <rect x={ox} y={oy+n*cs+24} width={12} height={12} fill="#f5b7b1"/>
              <text x={ox+16} y={oy+n*cs+35} fontSize="10" fill="#444">Off-diagonal (−kᵢ)</text>
              <rect x={ox} y={oy+n*cs+40} width={12} height={12} fill="#fafafa" stroke="#ddd"/>
              <text x={ox+16} y={oy+n*cs+51} fontSize="10" fill="#444">Zero (no connection)</text>
            </g>
          );
        })()}

        {/* ── MIDDLE: modal truncation ── */}
        <rect x={290} y={10} width={290} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={435} y={28} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Modal Truncation</text>
        <text x={435} y={44} textAnchor="middle" fontSize="11" fill="#555" fontStyle="italic">Keep only lowest p modes (p &lt; n)</text>

        {(() => {
          const n=8, barH=180, ox=310;
          // Show n=8 modes, first 3 highlighted
          const ωs=[0.2,0.5,0.9,1.4,2.1,3.0,4.1,5.4];
          const p=3;
          return (
            <g>
              {ωs.map((ω,i) => {
                const barLen=ω/ωs[ωs.length-1]*200;
                const col=i<p?'#2E75B6':'#ddd';
                const yp=62+i*28;
                return (
                  <g key={i}>
                    <rect x={ox+46} y={yp} width={barLen} height={20} rx={2} fill={col} opacity={i<p?1:0.6}/>
                    <text x={ox+40} y={yp+15} textAnchor="end" fontSize="11" fill={i<p?'#7B0D0D':'#aaa'} fontWeight={i<p?'700':'400'}>{'\u03C9'}{i+1}</text>
                    <text x={ox+46+barLen+4} y={yp+15} fontSize="10" fill={i<p?'#2E75B6':'#aaa'}>{i<p?'kept':'truncated'}</text>
                  </g>
                );
              })}
              <line x1={ox+46} y1={62} x2={ox+46} y2={62+n*28} stroke="#555" strokeWidth="1.5"/>
              {/* Bracket showing kept modes */}
              <rect x={ox} y={60} width={8} height={p*28} fill="none" stroke="#2E75B6" strokeWidth="2"/>
              <text x={ox-2} y={60+p*14} textAnchor="end" fontSize="11" fill="#2E75B6" fontWeight="700">p=3</text>
              {/* Explanation */}
              <rect x={296} y={288} width={278} height={42} rx={3} fill="#eaf3ff" stroke="#2E75B6" strokeWidth="1"/>
              <text x={302} y={304} fontSize="11" fill="#7B0D0D" fontWeight="700">Truncation error:</text>
              <text x={302} y={320} fontSize="10" fill="#444">Low-frequency loading → high modes</text>
              <text x={302} y={334} fontSize="10" fill="#444">contribute little → p=3 often sufficient</text>
            </g>
          );
        })()}

        {/* ── RIGHT: FEA link and solution algorithm ── */}
        <rect x={590} y={10} width={300} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={740} y={28} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Full MDoF Solution Algorithm</text>

        {[
          {n:'1', c:'#2E75B6', title:'Build [M], [K], [C]',          desc:'Assemble element matrices (FEA)\nor write by inspection for lumped'},
          {n:'2', c:'#c0392b', title:'Solve eigenvalue problem',      desc:'det([K]−ω²[M])=0 → ω₁²…ωₙ²\nBack-substitute → {φ₁}…{φₙ}'},
          {n:'3', c:'#27ae60', title:'Normalise mode shapes',         desc:'Divide by √(φᵀMφ) each mode\n[Φ]ᵀ[M][Φ] = I  (unit modal mass)'},
          {n:'4', c:'#e07b00', title:'Compute modal quantities',      desc:'fᵣ*(t) = {φᵣ}ᵀF(t)  (modal force)\nmᵣ*, kᵣ*, cᵣ*, ζᵣ for each mode r'},
          {n:'5', c:'#9b59b6', title:'Solve n SDOF modal equations',  desc:'qr̈ + 2ζᵣωᵣqṙ + ωᵣ²qᵣ = fᵣ*/mᵣ*\nAny SDOF solution method applies'},
          {n:'6', c:'#555',    title:'Superpose physical response',   desc:'x(t) = [Φ]{q(t)} = Σ {φᵣ}qᵣ(t)\nTruncate if p < n modes sufficient'},
        ].map(({n,c,title,desc},i) => (
          <g key={i}>
            <circle cx={602} cy={48+i*46} r={10} fill={c}/>
            <text x={602} y={53+i*46} textAnchor="middle" fontSize="12" fill="#fff" fontWeight="700">{n}</text>
            <text x={618} y={46+i*46} fontSize="11" fill="#7B0D0D" fontWeight="700">{title}</text>
            {desc.split('\n').map((l,j)=><text key={j} x={618} y={59+j*12+i*46} fontSize="9" fill="#444" fontFamily="'Courier New',monospace">{l}</text>)}
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>
        For an n-DOF system the stiffness matrix is banded (sparse) — only adjacent DOFs are coupled for a chain system. This makes large systems computationally tractable. Modal truncation retains only the lowest p modes, which dominate the response for smooth, low-frequency loading — reducing an n×n problem to p×p. The six-step modal analysis algorithm is general: it applies from a 2-DOF textbook problem to a million-DOF finite element model of an aircraft.
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────
// Main
// ─────────────────────────────────────────────────────────────────
export default function MDoFSystems() {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>Multi-Degree of Freedom (MDoF) Systems</h1>
      <p style={S.p}>
        Real structures — buildings, vehicles, aircraft, machines — have many independent directions of motion and therefore many natural frequencies and mode shapes. A Multi-Degree of Freedom (MDoF) system requires a coordinate for each independent motion, and its equation of motion is a system of coupled second-order ODEs. The power of MDoF analysis comes from matrix algebra: the equations of motion are written compactly as [M]ẍ + [C]ẋ + [K]x = F, and then decoupled through the modal transformation, reducing the coupled system to a set of independent SDOF problems — one per mode.
      </p>

      <InfoBox title="Core Ideas at a Glance" items={[
        "n-DOF system: n equations of motion, n natural frequencies, n orthogonal mode shapes",
        "Matrix EOM:  [M]ẍ + [C]ẋ + [K]x = F(t)   — coupled because [K] and [C] have off-diagonal terms",
        "[M] diagonal for lumped masses;  [K] symmetric, banded, assembled from element spring values",
        "Eigenvalue problem:  det([K] − ω²[M]) = 0  →  n natural frequencies ω₁² ≤ ω₂² ≤ … ≤ ωₙ²",
        "Mode shapes {φᵣ}: orthogonal with respect to [M] and [K] — {φᵣ}ᵀ[M]{φₛ} = 0 for r≠s",
        "Modal transformation x = [Φ]q decouples system: [Φ]ᵀ[M][Φ] = m* (diagonal), [Φ]ᵀ[K][Φ] = k* (diagonal)",
        "Each decoupled modal equation: mᵣ*q̈ᵣ + cᵣ*q̇ᵣ + kᵣ*qᵣ = fᵣ*(t)  →  solved as SDOF",
        "Physical response rebuilt by superposition:  x(t) = Σ {φᵣ} qᵣ(t)",
      ]}/>

      <h2 style={S.h2}>Equations of Motion — Matrix Form</h2>
      <p style={S.p}>
        For a system with n degrees of freedom, Newton's second law applied to each mass produces n simultaneous equations. These are written together as the matrix equation of motion [M]ẍ + [C]ẋ + [K]x = F(t). The coupling between equations — the fact that mass 1's motion affects mass 2's equation and vice versa — is encoded in the off-diagonal terms of [K] and [C]. The 2-DOF system below is the simplest non-trivial example: it has exactly one coupling spring connecting the two masses.
      </p>
      <DiagTwoDOFModel/>
      <Table2 rows={[
        ["Matrix EOM","[M]ẍ + [C]ẋ + [K]x = F(t)\nx = {x₁, x₂, …, xₙ}ᵀ  (displacement vector)\nF = {F₁, F₂, …, Fₙ}ᵀ  (force vector)"],
        ["Coupling condition","Off-diagonal terms in [K] or [C] couple the equations\nIf [K] and [M] are diagonal → equations decouple trivially\nCoupling arises from shared springs/dampers between DOFs"],
        ["DOF count","n = number of independent coordinates needed\nEqual to number of masses × directions of motion\nFor planar frame: each node has 3 DOF (x, y, θ)"],
        ["2-DOF wall-m₁-k₂-m₂","[M] = diag(m₁, m₂)\n[K] = [[k₁+k₂, −k₂], [−k₂, k₂]]\n[C] = 0 (undamped)  or similar structure if dampers present"],
        ["Generalising to n-DOF","Each additional mass adds one row and column to [M], [K], [C]\nMatrices grow as n×n but remain banded for chain systems\nFEA: millions of DOF, but still sparse — efficient solvers exist"],
      ]}/>

      <h2 style={S.h2}>Mass, Stiffness and Damping Matrices</h2>
      <p style={S.p}>
        Each matrix captures a distinct physical contribution to the dynamics. The mass matrix [M] stores inertia. The stiffness matrix [K] encodes the elastic restoring forces. The damping matrix [C] represents energy dissipation. Their structures are dictated by the system topology — which elements are connected to which DOFs — and by fundamental properties (symmetry, positive definiteness) that reflect physical conservation laws.
      </p>
      <DiagMatrices/>
      <Table2 rows={[
        ["[M] — lumped vs consistent","Lumped: diagonal, Mᵢᵢ = mᵢ (easy to invert)\nConsistent (FEA): non-diagonal from shape function integration\nLumped is simpler; consistent is more accurate for distributed systems"],
        ["[K] — assembly rule","Spring kᵢⱼ connecting DOF i and j: add +k to Kᵢᵢ, +k to Kⱼⱼ, −k to Kᵢⱼ and Kⱼᵢ\nFree end: no spring at last node — row/column has only one spring term\nFixed end: add spring to wall; equivalent spring appears only on diagonal"],
        ["[K] semi-definite","[K] is positive semi-definite (not positive definite) if rigid-body motion is allowed\nUnrestrained structure: one or more zero eigenvalues of [K]\nFixed structure: [K] is positive definite, all ωᵣ² > 0"],
        ["[C] — Rayleigh damping","[C] = α[M] + β[K]  (proportional / Rayleigh damping)\nα damps low-frequency modes; β damps high-frequency modes\nζᵣ = α/(2ωᵣ) + βωᵣ/2  — choose α,β to target two frequencies"],
        ["[C] — non-proportional","General [C] does not diagonalise with [Φ]ᵀ[C][Φ]\nComplex eigenvalue problem required; complex mode shapes\nComplex modes: components of motion not all in phase — seen in heavily-damped structures"],
        ["Symmetry","[M], [K], [C] are all symmetric: Aᵢⱼ = Aⱼᵢ (Maxwell reciprocity)\nSymmetry halves storage requirements\nEnsures real eigenvalues and orthogonal mode shapes"],
      ]}/>

      <h2 style={S.h2}>Eigenvalue Problem and Natural Frequencies</h2>
      <p style={S.p}>
        The natural frequencies and mode shapes are found from the undamped free-vibration problem. Assuming harmonic motion x = φ·cos(ωt) and substituting into [M]ẍ + [K]x = 0 yields the generalised eigenvalue problem ([K] − ω²[M])φ = 0. For a non-trivial solution the determinant must vanish, producing the characteristic polynomial whose roots are the squares of the natural frequencies.
      </p>
      <DiagEigenvalue/>
      <Table2 rows={[
        ["Generalised eigenvalue problem","([K] − ω²[M]){φ} = {0}\nEquivalent standard form: [M]⁻¹[K]{φ} = ω²{φ}\nω² = eigenvalue;  {φ} = eigenvector (mode shape)"],
        ["Characteristic polynomial","det([K] − ω²[M]) = 0\nn-DOF → degree-n polynomial in ω²\nn roots: ω₁² ≤ ω₂² ≤ … ≤ ωₙ² (ordered by size)"],
        ["Mode shape determination","Substitute each ωᵣ² back into ([K]−ωᵣ²[M]){φᵣ} = {0}\nSolve for relative amplitudes — magnitude is indeterminate\nConvention: normalise to unit modal mass or unit first component"],
        ["Counting theorem","n-DOF system always has exactly n natural frequencies\n(Complex eigenvalues appear for over/underconstrained systems)\nFor positive definite [K]: all ωᵣ² > 0"],
        ["Numerical methods","For large n: inverse power method (lowest ωₙ first)\nLanczos algorithm for sparse [K], [M] (FEA standard)\nSubspace iteration: simultaneously finds p lowest modes\nDirect: QR algorithm (dense, all modes, expensive for large n)"],
      ]}/>

      <h2 style={S.h2}>Normal Mode Shapes</h2>
      <p style={S.p}>
        Each natural frequency is associated with a unique pattern of motion called a normal mode shape. In a mode shape, all masses oscillate at the same frequency and maintain fixed amplitude ratios — they all pass through equilibrium simultaneously and reach their maximum displacements simultaneously. The number of nodes (zero-crossing points) in mode r equals r−1. Higher modes are more spatially complex and oscillate faster.
      </p>
      <DiagModeShapes/>
      <Table2 rows={[
        ["Mode shape definition","In mode r: all DOFs oscillate at ωᵣ with fixed amplitude ratios\nx(t) = {φᵣ}·Aᵣ·cos(ωᵣt + φ)  — single frequency, all in/out of phase\nNot a unique vector — any scalar multiple is also a valid mode shape"],
        ["Nodes","Mode r has r−1 internal nodes (points of zero displacement)\nMode 1: no nodes — all masses move together\nMode n: n−1 nodes — most complex, highest frequency"],
        ["Physical interpretation","Mode 1 (fundamental): long-wavelength, low energy, most easily excited\nHigher modes: short-wavelength, high frequency, need more energy to excite\nBuildings: mode 1 is sway; higher modes involve floors moving in opposite directions"],
        ["Mode shape normalisation","Unit modal mass: {φᵣ}ᵀ[M]{φᵣ} = 1  (most common in modal analysis)\nUnit first component: φᵣ₁ = 1  (simple, easy to interpret)\nUnit Euclidean length: |{φᵣ}| = 1  (less physical meaning)"],
        ["Orthogonality","M-orthogonality: {φᵣ}ᵀ[M]{φₛ} = 0 for r≠s\nK-orthogonality: {φᵣ}ᵀ[K]{φₛ} = 0 for r≠s\nPhysical meaning: modes do not exchange energy (for undamped or Rayleigh-damped systems)"],
        ["Completeness","Any displacement vector can be expressed as x = Σ cᵣ{φᵣ}\nModal expansion coefficients: cᵣ = {φᵣ}ᵀ[M]x / mᵣ*\nCompleteness is why modal superposition gives the exact response"],
      ]}/>

      <h2 style={S.h2}>Coupled and Uncoupled Equations</h2>
      <p style={S.p}>
        In physical (Cartesian) coordinates the equations of motion are coupled — you cannot solve for x₁(t) without simultaneously knowing x₂(t). The modal transformation x = [Φ]q converts to modal coordinates q where — thanks to orthogonality — all matrices become diagonal. The coupled system of n equations becomes n completely independent SDOF equations in the modal amplitudes qᵣ(t). Each is solved with the tools from SDOF analysis, and the physical response is recovered by superposition.
      </p>
      <DiagModalTransform/>
      <DiagCoupledUncoupled/>
      <Table2 rows={[
        ["Modal matrix [Φ]","[Φ] = [{φ₁} {φ₂} … {φₙ}]  — n×n matrix of column eigenvectors\nChanges coordinates: x = [Φ]q  (physical from modal)\nInverse: q = [Φ]⁻¹x = [Φ]ᵀ[M]x  (for mass-normalised modes)"],
        ["Diagonalisation","[Φ]ᵀ[M][Φ] = diag(m₁*, m₂*, …)  — modal mass matrix\n[Φ]ᵀ[K][Φ] = diag(k₁*, k₂*, …)  — modal stiffness matrix\n[Φ]ᵀ[C][Φ] = diag(c₁*, c₂*, …)  — only for proportional [C]"],
        ["Decoupled modal equation","mᵣ*q̈ᵣ + cᵣ*q̇ᵣ + kᵣ*qᵣ = fᵣ*(t)\nModal frequency: ωᵣ² = kᵣ*/mᵣ*\nModal damping: ζᵣ = cᵣ*/(2√(kᵣ*mᵣ*))"],
        ["Modal forcing","fᵣ*(t) = {φᵣ}ᵀ F(t)\nProjects physical force onto mode r — scalar product\nMode not excited if F(t) is orthogonal to {φᵣ} (e.g. force at a node of mode r)"],
        ["Superposition (rebuild)","x(t) = [Φ]{q(t)} = Σᵣ {φᵣ} qᵣ(t)\nEach mode contributes independently\nDominant modes: modes with largest fᵣ* and/or frequencies closest to forcing frequency"],
        ["Initial conditions in modal","q(0) = [Φ]ᵀ[M]x(0)  (modal initial displacement)\nq̇(0) = [Φ]ᵀ[M]ẋ(0)  (modal initial velocity)\nThen solve each modal SDOF for qᵣ(t) independently"],
      ]}/>

      <h2 style={S.h2}>Orthogonality</h2>
      <DiagOrthogonality/>

      <h2 style={S.h2}>Scaling to n-DOF, FEA and Modal Truncation</h2>
      <DiagGeneralMDOF/>
      <Table2 rows={[
        ["FEA and MDoF","Finite element models have millions of DOF\nSame [M]ẍ + [K]x = F structure — matrices are huge but sparse\nSparse solvers (PARDISO, MUMPS) exploit zero structure for efficiency"],
        ["Banded matrix storage","Chain/frame structures: [K] is banded — non-zeros near diagonal\nBand half-width b: node reordering (Cuthill-McKee) minimises b\nStorage O(nb) instead of O(n²) — enables million-DOF systems"],
        ["Modal truncation","Keep only p lowest modes (p << n for smooth loading)\nTruncation error: neglected high modes contribute to static residual\nResidual correction: add pseudo-static contribution of truncated modes"],
        ["Mode participation factor","Γᵣ = {φᵣ}ᵀ[M]{1} / mᵣ*   (for base excitation {1} = rigid-body vector)\nHigh |Γᵣ|: mode strongly excited by base motion\nEffective mass: Mᵣ,eff = Γᵣ²·mᵣ*   (sum = total mass for complete set)"],
        ["Mass participation check","Σ Mᵣ,eff / M_total ≥ 90% → sufficient modes included\nSeismic codes (IBC, Eurocode 8) require this criterion\nTypically 10–20 modes needed for building response"],
        ["Dynamic substructuring","Divide large structure into substructures with few interface DOFs\nCraig-Bampton method: fixed-interface modes + interface DOFs\nReduces DOF dramatically while maintaining accuracy at interfaces"],
      ]}/>

      <InfoBox title="Key Formulae Summary" items={[
        "Matrix EOM:  [M]ẍ + [C]ẋ + [K]x = F(t)",
        "Eigenvalue problem:  det([K] − ω²[M]) = 0  →  ωᵣ² eigenvalues,  {φᵣ} eigenvectors",
        "Orthogonality:  {φᵣ}ᵀ[M]{φₛ} = 0  and  {φᵣ}ᵀ[K]{φₛ} = 0  for r ≠ s",
        "Modal mass:  mᵣ* = {φᵣ}ᵀ[M]{φᵣ}   |   Modal stiffness:  kᵣ* = {φᵣ}ᵀ[K]{φᵣ} = ωᵣ²·mᵣ*",
        "Modal transformation:  x = [Φ]q   |   [Φ]ᵀ[M][Φ] = m*,  [Φ]ᵀ[K][Φ] = k*  (diagonal)",
        "Decoupled modal EOM:  mᵣ*q̈ᵣ + cᵣ*q̇ᵣ + kᵣ*qᵣ = fᵣ*(t) = {φᵣ}ᵀF(t)",
        "Rayleigh damping:  [C] = α[M] + β[K]   |   ζᵣ = α/(2ωᵣ) + βωᵣ/2",
        "Physical response (superposition):  x(t) = [Φ]{q(t)} = Σ {φᵣ}qᵣ(t)",
      ]}/>
    </div>
  );
}